import { Component } from '@angular/core';
import { NavParams, NavController, ModalController } from 'ionic-angular';

import { Horse } from '../../model/horse';
import { AddHorsePage } from './add-horse';
import { ViewHorsePicturePage } from './view-horse-picture';

@Component({
    selector: 'page-horses',
    templateUrl: 'horses.html'
})
export class HorsesPage {
    imageHostUrl: string = "https://nextgenrodeomedia.blob.core.windows.net/images/";
    horses: Horse[];

    popoverActive: boolean;

    constructor(navParams : NavParams, private nav: NavController, private modalCtrl: ModalController) {
        this.horses = navParams.get("horses");
    }

    showHorsePopup(horse) {
        if (this.popoverActive)
			return;

		this.popoverActive = true;

        let popover = this.modalCtrl.create(AddHorsePage, {
            horse: horse
        }, { cssClass: 'page-add-horse' });
    
        popover.present();

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            if (data != null && data.horse != undefined) {
                if (horse == null || horse == undefined) {
                    this.horses.push(data.horse);
                } else {
                    for (let i = 0; i < this.horses.length; i++)  {
                        if (this.horses[i].id == data.horse.id) {
                            this.horses[i] = data.horse;
                            break;
                        }
                    }
                }
            }
        })
    }

    showCoggins(horse) {
        if (this.popoverActive || !horse.cogginsFileName || horse.cogginsFileName == "")
            return;

        this.popoverActive = true;
        let entryModal = this.modalCtrl.create(ViewHorsePicturePage, { cogginsPictureUrl: this.imageHostUrl + horse.cogginsFileName }, { cssClass: 'page-view-horse-picture', enableBackdropDismiss: true });

        entryModal.present();
        this.popoverActive = false;
    }

    showRegistration(horse) {
        if (this.popoverActive || !horse.registrationPaperFileName || horse.registrationPaperFileName == "")
            return;

        this.popoverActive = true;
        let entryModal = this.modalCtrl.create(ViewHorsePicturePage, { pictureUrl: this.imageHostUrl + horse.registrationPaperFileName }, { cssClass: 'page-view-horse-picture', enableBackdropDismiss: true });

        entryModal.present();
        this.popoverActive = false;
    }

    back() {
        this.nav.pop();
    }
}


// WEBPACK FOOTER //
// ./src/pages/horse/horses.ts